<template>
  <v-container>
    <v-row>
      <v-col
        :cols="totalCols"
        :md="mdCols"
        :lg="lgCols"
        v-for="(val, i) in values"
        :key="val.label"
        :class="itemClass(i, values)"
      >
        <v-card>
          <v-card-title class="text-h6 primary--text">{{
            val.label
          }}</v-card-title>
          <v-card-text class="text-start pb-2">
            <v-divider />
            <span class="text-h2 primary--text font-weight-bold">
              {{ val.value }}</span
            >
            <v-divider />
            <div class="d-flex justify-space-between mt-4">
              <div>
                <span>
                  <v-icon
                    v-if="isIncrease(val.value, val.prevDayValue)"
                    left
                    color="green"
                    >mdi-arrow-up-bold</v-icon
                  >
                  <v-icon v-else left color="red">mdi-arrow-down-bold</v-icon>

                  <span
                    v-if="isIncrease(val.value, val.prevDayValue)"
                    class="mx-1 green--text"
                    >{{ getPercentageChange(val.value, val.prevDayValue)
                    }}<sup>%</sup></span
                  >
                  <span v-else class="mx-1 red--text"
                    >{{ getPercentageChange(val.value, val.prevDayValue)
                    }}<sup>%</sup></span
                  >
                </span>
                <div>Since Previous Day</div>
              </div>
              <v-avatar color="background">
                <v-icon large color="primary"> {{ val.icon }}</v-icon>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'DailyReportSummary',
  data() {
    return {
      totalCols: 12
    }
  },
  computed: {
    lgCols() {
      return this.values.length % 4 === 0 ? 3 : this.values.length % 3 === 0 ? 4 : 6;
    },
    mdCols() {
      return this.values.length % 4 === 0 ? 6 : this.values.length % 3 === 0 ? 4 : 6;
    }
  },
  props: {
    dailyReport: {
      type: Object,
      required: true,
    },
    values: {
      type: Array,
      required: true,
    },
  },
  methods: {
    itemClass(index, values) {
      const breakpoint = this.$vuetify.breakpoint;
      if (breakpoint.sm || breakpoint.xs) return 'px-0'; // single column, no left right padding

      // Figuring out the unpadding for wrapping cards
      if (breakpoint.lg || breakpoint.md) {
        var noOfColumns = this.totalCols / (breakpoint.lg ? this.lgCols : this.mdCols);
        var modulus = index % noOfColumns;
        if (modulus === 0) return 'pl-0'; // Left unpad left column
        if (modulus === noOfColumns - 1) return 'pr-0'; // Right unpad right column
      }

      return (index === values.length - 1 && 'pr-0') || (index === 0 && 'pl-0');
    },
    isIncrease(a, b) {
      return a >= b;
    },
    getPercentageChange(newNumber, oldNumber) {
      if (oldNumber === 0) return 'N/A';
      const increaseValue = newNumber - oldNumber;

      const percentage = ((increaseValue / oldNumber) * 100).toFixed(2);

      const result = percentage >= 0 ? `+${percentage}` : percentage;
      return result;
    },
  },
};

</script>

<style>
.per-day-summary-header-container {
  display: block;
}

.per-day-summary-value-container {
  display: block;
  min-width: 250px;
  margin: auto;
  margin-top: 32px;
}

@media only screen and (min-width: 960px) {
  .per-day-summary-header-container {
    display: flex;
    justify-content: space-around;
  }
}
</style>
